import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, reactive, watch } from 'vue';
import { ON_BEHALF_OF_CLIENT_INJECT_KEY } from 'ah-common-lib/src/onBehalfOf/constants';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { Client } from 'ah-api-gateways';
import { useAhWalletsState } from '..';
import WalletsFormattedCurrency from '../currency/WalletsFormattedCurrency.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WalletBalance',
  props: {
    currency: null,
    showAvailable: { type: [String, Boolean], default: false }
  },
  setup(__props: any) {

const props = __props as { currency: string, showAvailable: string | boolean };

const walletState = useAhWalletsState();

const requestManager = useRequestManager({
  exposeToParent: ['loadWallet'],
  onRetryFromParentManager: onRetryFromParentManager,
});

const state = reactive<{
  onBehalfOfClient: Client | null;
}>({
  onBehalfOfClient: inject(ON_BEHALF_OF_CLIENT_INJECT_KEY, null),
});



function onRetryFromParentManager(k: string) {
  if (k === 'loadWallet') {
    loadWallet();
  }
}

const shouldShowAvailable = computed(() => props.showAvailable !== false);

const balance = computed(
  () => (shouldShowAvailable.value ? wallet.value?.availableBalance : wallet.value?.balance) || 0
);

const wallet = computed(() => {
  return walletState.store.useWalletsStore().getWallet(props.currency, {
    isPartner: isPartnerUser.value,
    id: ownerId.value,
  });
});

const walletQuery = computed(() => {
  return {
    currency: props.currency,
    owner: { isPartner: isPartnerUser.value, id: ownerId.value },
  };
});

const isPartnerUser = computed(() => !state.onBehalfOfClient && !walletState.store.useAuthStore().isClientUser);

const ownerId = computed(() => {
  if (state.onBehalfOfClient) {
    return state.onBehalfOfClient.id;
  }
  return (
    walletState.store.useAuthStore().loggedInIdentity?.client?.id ||
    walletState.store.useAuthStore().loggedInIdentity?.partner?.id
  );
});

function loadWallet() {
  requestManager.manager.newPromise(
    'loadWallet',
    walletState.store.useWalletsStore().loadCurrencyWallet(walletQuery.value)
  );
}

watch(
  walletQuery,
  () => {
    loadWallet();
  },
  { immediate: true }
);

return { __sfc: true,walletState, requestManager, state, props, onRetryFromParentManager, shouldShowAvailable, balance, wallet, walletQuery, isPartnerUser, ownerId, loadWallet, WalletsFormattedCurrency }
}

})